// extracted by mini-css-extract-plugin
export var aboveInput = "_k7-0";
export var actionButton = "_k7-5";
export var actionButtonContainer = "_k7-1";
export var actionIcon = "_k7-6";
export var aiInfoContainer = "_k7-2";
export var attachmentWrapper = "_k7-7";
export var bold = "_k7-3";
export var checkIcon = "_k7-8";
export var clickingRecipientBar = "_k7-11";
export var commentThreadSwitch = "_k7-a";
export var draftImage = "_k7-b";
export var draftImageContainer = "_k7-c";
export var draftImages = "_k7-e";
export var editButton = "_k7-g";
export var editor = "_k7-f";
export var editorContainer = "_k7-y";
export var editorErrorTooltipWrapper = "_k7-9";
export var headerDivider = "_k7-h";
export var icon = "_k7-i";
export var info = "_k7-j";
export var internal = "_k7-n";
export var internalDivider = "_k7-k";
export var internalMessage = "_k7-l";
export var messageInputCard = "_k7-m";
export var messageInputForm = "_k7-o";
export var messageInputFormInternal = "_k7-p";
export var options = "_k7-q";
export var publicMessageCustomer = "_k7-s";
export var publicMessageMerchant = "_k7-r";
export var removeImageButton = "_k7-d";
export var replyButtons = "_k7-t";
export var showSignatureButton = "_k7-u";
export var spinner = "_k7-v";
export var verticalButtonDivider = "_k7-4";
export var visibilitySelector = "_k7-w";
export var warning = "_k7-x";
export var wrappingText = "_k7-z";
export var writingInternalNoteTopBorder = "_k7-10";